import { createSlice } from '@reduxjs/toolkit';

const ruleSectionsSlice = createSlice({
  name: 'ruleSections',
  initialState: [],
  reducers: {
    setRuleSections: (state, action) => {
      return action.payload;
    },
  },
});

export const { setRuleSections } = ruleSectionsSlice.actions;

export default ruleSectionsSlice.reducer;